const applicationVersions = [
  {
    version: '3.0.5',
  }
];

export const version = applicationVersions[0].version;
